import React, { useState } from 'react';
import '../Navbar.css'; 


const Navbar = ({link, linkText}) => {
  const [isActive, setIsActive] = useState(false);

  const toggleMenu = () => {
    setIsActive(!isActive);
  };

  return (
    <div className="navbar">
      <div className="hamburger-menu" onClick={toggleMenu}>
        <div className="line line-1"></div>
        <div className="line line-2"></div>
        <div className="line line-3"></div>
      </div>

      <div className={`navbar-links ${isActive ? 'active' : ''}`}>
        <a href="/mainmenu">Home</a>
        <a href="/csv">Upload</a>
        <a href="/query">Query</a>
        <a href="/find">Find Submission</a>
        <a href="/offboard">Offboard</a>
        <a href="/offboardbulk">Bulk Offboard</a>
        <a href="/getstats">Stats</a>
        <a href="/changepassword">Change Password</a>
        <a href={link}>{linkText}</a>
      </div>
    </div>
  );
};

export default Navbar;
